// app/javascript/packs/archives.js
$(document).on("turbolinks:load", function initArchives() {
  let archiveTypeButton = null;
  let count = 0;
  let attribute = "archives[archives_attributes]";

  function isOperationExecutive() {
    const v = $("#docs-backoffice").data("operation-executive");
    return v === true || String(v) === "true";
  }

  function shouldShowContractSelect(archiveType) {
    return archiveType === "document_contract" && isOperationExecutive();
  }

  function getFileExtension3(filename) {
    return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
  }

  // === helper: required ON solo si no hay tarjetas; OFF si ya hay ===
  function syncDropzoneRequired() {
    if ($(".container-archives-form").html() === undefined) return;

    const empty = $(".container-archives-form").html().trim() === "";
    $(".container-archives .input-archives").prop("required", empty);
  }

  // Crea un <input type="file"> con UN solo archivo (para cada item)
  function buildSingleFileInput(nameAttr, file) {
    const $inp = $("<input>", {
      type: "file",
      name: nameAttr, // ej: archives[archives_attributes][][url]
      class: "d-none input-archives-single",
      required: "required",
    });
    const dt = new DataTransfer();
    dt.items.add(file);
    $inp[0].files = dt.files;
    return $inp;
  }

  // Renderiza SIEMPRE una dropzone fresca
  function renderDropzone(idx, attr) {
    const dragAndDrop = `
      <div class="container-form" id="input_${idx}">
        <div class="form-group file-area input_${idx}">
          <input class="input-archives" data-label="label-file-${idx}" data-id="input_${idx}"
                 type="file" required="required" name="${attr}[][url]" multiple>
          <div class="file-dummy">
            <div class="success"></div>
            <div class="default">
              <strong>Arrastra el archivo para cargarlo</strong><br>
              o examina en tu computador
            </div>
          </div>
        </div>
        <div class="label-archive-format" id="label-file-${idx}"></div>
      </div>`;
    $(".container-archives").html(dragAndDrop);

    // clave: si ya hay tarjetas, apaga required aquí mismo
    syncDropzoneRequired();
  }

  function removeArea() {
    $(".container-archives, .container-archives-form").html("");
  }

  function addHiddenFieldsArchive() {
    $(".archive-type").val(archiveTypeButton || "");
  }

  // ---------- Eventos generales del modal ----------
  $(".close-modal").on("click", function () {
    $(".form-control-partners-modal").val("");
    $(".form-control-archives-modal").val("");
    $(".input-archives").val("");
    $(".container-files").html("");
    $(".submit-archive").addClass("disabled").prop("disabled", true);
    $(".button-close").click();
    removeArea();
    $("#select-archive-type").val("");
    $(".select-contract-type").val("");
    $(".is-factoring-contract").val("false");
  });

  $("#modalarchive").on("hidden.bs.modal", function () {
    removeArea();
  });

  $("body").on(
    "click",
    ".button-archives, .button-archives-operations",
    function () {
      archiveTypeButton = $(this).data("archive") || null; // ej: "document_contract"
    }
  );

  $("body").on("click", ".button-archives", function () {
    removeArea();
    renderDropzone(count, attribute);
  });

  $("body").on("click", ".button-archives-operations", function () {
    attribute = $(this).data("attributes") || attribute;
  });

  $("body").on("change", "#select-archive-type", function () {
    archiveTypeButton = $(this).val();
    $(".archive-type").val(archiveTypeButton);
  });

  // ---------- MULTI-UPLOAD ----------
  $("body")
    .off("change", ".input-archives")
    .on("change", ".input-archives", function () {
      const files = Array.from(this.files || []);
      if (files.length === 0) return;

      const label = $(this).data("label");
      const dataAttachmentableId = $("#submit-archives").data("controller");
      const dataAttachmentableType = $("#submit-archives").data("type");
      const dataUserId = $("#submit-archives").data("user");
      const nameAttr = $(this).attr("name"); // ej: archives[archives_attributes][][url]

      files.forEach((file) => {
        addForm(
          file,
          count,
          dataAttachmentableId,
          dataAttachmentableType,
          dataUserId,
          attribute,
          archiveTypeButton
        );
        // input oculto con SOLO este archivo
        buildSingleFileInput(nameAttr, file).appendTo(
          "#input-file-archive-" + count
        );
        count++;
      });

      // Limpia el input usado y evita validación HTML5 sobre él
      this.value = "";

      // === required: ya hay archivos -> OFF
      $(".container-archives .input-archives").prop("required", false);

      addHiddenFieldsArchive();
      $("#" + label).fadeOut(100);

      // Habilita botón de submit
      $(".submit-archive").removeClass("disabled").prop("disabled", false);

      // Reponer dropzone para seguir agregando más archivos
      renderDropzone(count, attribute);

      // Asegurar que la NUEVA dropzone no quede required si ya hay tarjetas
      $(".container-archives .input-archives").prop("required", false);
    });

  // Enviar: el input visible NO debe bloquear si ya hay tarjetas
  $(document).on("submit", "form", function () {
    if ($(this).find("#submit-archives").length) {
      const hasCards = $(".container-archives-form").html().trim() !== "";
      $(this).find(".input-archives").prop("required", !hasCards);
      // No deshabilitamos el input; no hace falta.
    }
  });

  // ---------- Render de cada tarjeta de archivo ----------
  function addForm(
    file,
    idx,
    dataAttachmentableId,
    dataAttachmentableType,
    dataUserId,
    attr,
    archiveType
  ) {
    const name = file.name;
    const size = (file.size / 1024).toFixed(2);

    const contractSelectHTML = shouldShowContractSelect(archiveType)
      ? `
      <div class="col-sm-12 col-md-4">
        <div class="form-group">
          <label for="company_archives_attributes_contract_type_${idx}">Tipo de contrato</label>
          <select class="form-control form-control-archives-modal select-contract-type"
                  id="company_archives_attributes_contract_type_${idx}"
                  name="${attr}[][contract_type]">
            <option value="">Sin seleccionar</option>
            <option value="factoring">Contrato Factoring</option>
            <option value="leasing">Contrato Leasing</option>
            <option value="credit_assignment">Cesión de crédito</option>
            <option value="quotation">Cotización</option>
            <option value="other">Otros</option>
          </select>
        </div>
      </div>`
      : "";

    const hiddenIsFactoring = `<input type="hidden" class="is-factoring-contract" name="${attr}[][is_factoring_contract]" value="false">`;

    const parametersArchive = `
      <div class="container-uploading-archives">
        <div id="input-file-archive-${idx}"></div>
        <button type="button" class="close button-close ml-auto">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="d-flex flex-row row-archive w-80">
          <div class="">
            <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.2302 4.59281L13.323 0.660937C12.9038 0.239063 12.3355 0 11.7444 0H2.23541C1.00149 0.0046875 0 1.0125 0 2.25422V21.7505C0 22.9922 1.00149 24 2.23541 24H15.6516C16.8855 24 17.887 22.9922 17.887 21.7505V6.18609C17.887 5.59125 17.6494 5.01469 17.2302 4.59281ZM11.9261 1.52766C12.0565 1.56047 12.1729 1.62609 12.2708 1.72453L16.178 5.65641C16.2758 5.75484 16.341 5.87203 16.3736 6.00328H11.9261V1.52766ZM16.3969 21.7505C16.3969 22.163 16.0615 22.5005 15.6516 22.5005H2.23541C1.8255 22.5005 1.49012 22.163 1.49012 21.7505V2.25422C1.49012 1.84172 1.8255 1.5 2.23541 1.5H10.4355V6.37828C10.4355 7.00172 10.9339 7.5 11.5534 7.5H16.3969V21.7505Z" fill="#0055B8"/>
            </svg>
          </div>
          <div class="ml-3 name-file">${name}</div>
          <div class="ml-4 name-size name-file">${size} KB</div>
        </div>

        <div class="row mt-40 mb-3">
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="company_archives_attributes_name_${idx}">Nombre</label>
              <input class="form-control form-control-archives-modal" placeholder="Nombre Archivo..." type="text"
                     id="company_archives_attributes_name_${idx}" name="${attr}[][name]">
              <div class="error"></div>
            </div>
          </div>

          ${contractSelectHTML}
          ${hiddenIsFactoring}

          <div class="col-sm-12 col-md-12">
            <div class="form-group">
              <label for="company_archives_attributes_observations_${idx}">Observaciones</label>
              <input class="form-control form-control-archives-modal" placeholder="Observaciones..." type="text"
                     id="company_archives_attributes_observations_${idx}" name="${attr}[][observations]">
            </div>
          </div>

          <input type="hidden" class="archive-type" name="${attr}[][archive_type]">
          <input type="hidden" value="${dataUserId}" class="id-of-user" name="${attr}[][user_id]">
          <input type="hidden" value="${dataAttachmentableId}" class="company-id" name="${attr}[][attachmentable_id]">
          <input type="hidden" value="${dataAttachmentableType}" class="company-id" name="${attr}[][attachmentable_type]">
        </div>
      </div>
    `;

    $(parametersArchive)
      .hide()
      .prependTo(".container-archives-form")
      .fadeIn(1000);
  }

  // --------- Resto de handlers (sin cambios de negocio) ---------
  $("body").on("change", ".input-sii-signature", function () {
    const file = $(this).prop("files")[0];
    const name = file.name;
    if (
      getFileExtension3(name) === "pfx" ||
      getFileExtension3(name) === "p12"
    ) {
      $(".file-preview .file-name").html(name);
      $(".file-size").html((file.size / 1024).toFixed(2) + " KB");
      $(".file-preview").removeClass("hide");
      $(".file-area").hide();
      $("#sii_credential_electronic_signature")
        .parent()
        .siblings(".error")
        .html("");
    } else {
      $(".file-area").find(".subtitle").hide();
      $("#sii_credential_electronic_signature")
        .parent()
        .siblings(".error")
        .html(
          `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M7.5 0C3.35835 0 0 3.35835 0 7.5C0 11.6416 3.35835 15 7.5 15C11.6416 15 15 11.6416 15 7.5C15 3.35835 11.6441 0 7.5 0ZM8.33225 11.8277C8.09726 12.0627 7.79863 12.1679 7.48042 12.1679C7.16221 12.1679 6.86358 12.0602 6.62859 11.8277C6.3936 11.5927 6.26632 11.3161 6.26632 10.9954C6.26632 10.6968 6.3936 10.3982 6.62859 10.1632C6.86358 9.9282 7.16221 9.80091 7.48042 9.80091C7.82066 9.80091 8.09726 9.9282 8.33225 10.1632C8.56723 10.3982 8.69452 10.6748 8.69452 10.9954C8.69452 11.3161 8.56723 11.5927 8.33225 11.8277ZM8.63088 4.70953C8.56723 5.03019 8.48156 5.3484 8.41792 5.68864C8.31 6.051 8.205 6.499 8.097 7.03C7.99 7.564 7.862 8.244 7.735 9.054H7.245C7.118 8.244 6.991 7.583 6.883 7.03C6.775 6.477 6.67 6.029 6.585 5.667C6.499 5.282 6.413 4.942 6.35 4.665C6.286 4.389 6.264 4.154 6.264 3.983C6.242 3.642 6.372 3.366 6.626 3.15C6.881 2.915 7.16 2.81 7.5 2.81C7.84 2.81 8.139 2.918 8.374 3.15C8.609 3.385 8.736 3.662 8.736 3.983C8.736 4.156 8.695 4.389 8.631 4.71Z" fill="#FF5C4E"/>
         </svg> Formato de archivo incorrecto. Cargar sólo en PFX o P12.`
        );
    }
  });

  $("body").on("click", ".file-preview .close", function () {
    $(".file-area").show();
    $(".file-area").find(".subtitle").show();
    $(".file-preview").addClass("hide");
    $(".file-preview .file-name").html("");
    $(".input-sii-signature").val("");
    if (
      $(".input-sii-signature").val("").val() == "" ||
      $("#sii_credential_electronic_signature_password").val() == ""
    ) {
      $("#buttons-modal-sii").find('input[type="submit"]').addClass("disabled");
    } else {
      $("#buttons-modal-sii")
        .find('input[type="submit"]')
        .removeClass("disabled");
    }
  });

  $("body").on("click", ".link-download-archives", function (e) {
    e.preventDefault();
    const url = $(this).data("url");
    window.open(url);
  });

  $("body").on("click", ".show-document-eye", function () {
    const close_icon = $("#close-document-button > span > svg > path");
    close_icon.attr("fill", "#0055B8");
    const url = $(this).data("url");
    const $modal = $("#show-document-modal");
    $modal.find("#document-display-div").html(
      $("<embed></embed>", {
        width: "100%",
        height: "50vh",
        src: url,
        id: "document-opener",
      })
    );
    $("#download-document").data("url", url);
    $("#show-document-modal").modal("toggle");
  });

  $("body").on("click", ".tab-item", function () {
    if (!$(this).hasClass("active")) {
      const pageLink = $(".page-link")[0];
      if (pageLink && pageLink.innerHTML !== "1") pageLink.click();
    }
  });

  $("body").on("click", ".delete-button-archive", function () {
    $(".loader").fadeIn();
    setTimeout(() => $(".loader").fadeOut(), 500);
  });

  // Botón submit activo/inactivo según existan tarjetas + REQUIRED de la dropzone
  const targetNode = document.querySelector(".container-archives-form");
  if (targetNode) {
    const config = { childList: true, subtree: true };
    const observer = new MutationObserver(function () {
      const empty = targetNode.innerHTML.trim() === "";
      $(".submit-archive")
        .toggleClass("disabled", empty)
        .prop("disabled", empty);
      // mantener required coherente
      syncDropzoneRequired();
    });
    observer.observe(targetNode, config);
  }

  $("body").on("change", "#archive_url_insurance", function () {
    const $dummy = $(".file-area-change-success").find(".file-dummy");
    $dummy.addClass("file-dummy-success");
    $dummy.find(".success").removeClass("d-none");
    $dummy.find(".default").addClass("d-none");
  });

  $("body").on("change", ".select-contract-type", function () {
    const val = $(this).val();
    const $container = $(this).closest(".container-uploading-archives");
    $container
      .find(".is-factoring-contract")
      .val(val === "factoring" ? "true" : "false");
  });

  $(document).on("click", ".archives-actions-menu .dropdown-item", function () {
    $(this)
      .closest(".dropdown")
      .find("[data-toggle='dropdown']")
      .dropdown("hide");
  });

  $(document).on("click", ".open-archive-details", function () {
    $(this)
      .closest(".dropdown")
      .find("[data-toggle='dropdown']")
      .dropdown("hide");
  });

  // Primera dropzone al abrir
  renderDropzone(count, attribute);
});
